import {
  CsobFormMetaDataDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_CSOB } from "../domain";

import { csobHubApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CSOB_FORMS_METADATA = "GET_CSOB_FORMS_METADATA";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

export const fetchCsobFormsMetadata = async (): Promise<CsobFormMetaDataDto[]> => {
  const response = await csobHubApi.csobHubControllerGetForms();

  return response.data;
};

export const useGetCsobFormsMetadata = (
  user: UserProfileDto | null,
): {
  availableFormsMetadata: CsobFormMetaDataDto[] | undefined;
  availableFormsMetadataEnabled: boolean;
  formsError: Error | null;
  refetcCsobFormsMetadata: () => void;
  isLoadingFormsMetadata: boolean;
  isFetchingFormsMetadata: boolean;
  isSuccessFormsMetadata: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryResult = useQuery<CsobFormMetaDataDto[], Error>({
    queryKey: [DOMAIN_CSOB, ACTION_GET_CSOB_FORMS_METADATA],
    queryFn: fetchCsobFormsMetadata,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    availableFormsMetadata: queryResult.data,
    availableFormsMetadataEnabled: enabled,
    formsError: queryResult.error,
    refetcCsobFormsMetadata: queryResult.refetch,
    isLoadingFormsMetadata: queryResult.isLoading,
    isFetchingFormsMetadata: queryResult.isFetching,
    isSuccessFormsMetadata: queryResult.isSuccess,
  };
};
